import React from 'react';

const HoursOperation = () => {
    return (
        <div className="hours-operation float-right">
            <img src={process.env.PUBLIC_URL + '/assets/images/operation.png'} alt="operation"/>
            <h4>HORÁRIO DE ATENDIMENTO</h4>
            <span>Segunda a sexta, das 7h15 às 18h</span>
        </div>
    );
}
 
export default HoursOperation;